import {
  Component,
  inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DocumentSagaState, TemplateType } from '@core/core.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { of } from 'rxjs';
import { ReportSagaState } from '@app/modules/reports/types/report.types';

@Component({
  selector: 'app-document-approval-saga-confirm',
  imports: [DataTableComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './document-approval-saga-confirm.component.html',
})
export class DocumentApprovalSagaConfirmComponent implements OnInit {
  private modalRef = inject(NgbActiveModal);
  private translateService = inject(TranslateService);

  @Input() state: DocumentSagaState | ReportSagaState;

  configuration: DataTableConfiguration;

  ngOnInit() {
    this.configuration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      columns: [
        {
          label: '',
          property: 'data',
        },
        {
          label: 'pii.details.approve.sagaConfirm.columns.type',
          property: 'type',
          customStyle: 'padding-right: 30px;',
        },
      ],
      rows$: of([
        ...this.state.errors.map((error) => ({
          data: error,
          type: this.translateService.instant(
            'pii.details.approve.sagaConfirm.types.error'
          ),
        })),
        ...this.state.warnings.map((warning) => ({
          data: warning,
          type: this.translateService.instant(
            'pii.details.approve.sagaConfirm.types.warning'
          ),
        })),
      ]),
    };
  }

  dismiss(response) {
    this.modalRef.close(response);
  }

  protected readonly TemplateType = TemplateType;
}
